import { Injectable } from '@angular/core';

@Injectable()
export class DocumentUploaderService {

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/pages/customer-account/services/document-uploader.service.ts